var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-dropdown',{attrs:{"placement":"bottomRight"}},[_c('div',{staticClass:"header",staticStyle:{"background":"#892E65!important","width":"45px","text-align":"center"},on:{"click":function($event){return _vm.handleToCenter()}}},[_c('a-icon',{staticStyle:{"color":"#fff","font-size":"24px"},attrs:{"type":"profile"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }